
import { Component, Prop, Vue } from 'vue-property-decorator';
import { syncRecordList } from '@/api/users';
import { UserModule } from '@/store/modules/user';
import { IPagination } from '@/types';

@Component({
  name: 'StaffSyncrecord',
  components: {

  }
})
export default class extends Vue {
  // 页面参数定义
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private tableData = [];
  private loading=false
  private radio='2';

  created() {
    this.syncRecordList();
  }
  private tabHandle() {
    this.syncRecordList();
  }
  private syncRecordList() {
    const params = {
      company_id: UserModule.getCompanyId,
      sync_type: parseInt(this.radio),
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    syncRecordList(params)
      .then(res => {
        if (res.data) {
          this.pagination.total = res.data.count;
          this.tableData = res.data.list;
        } else {
          this.tableData = [];
        }
      })
      .catch(err => {
        this.tableData = [];
        let msg = err.msg;
      });
  }

  // 页面切换
  handleCurrentChange(page: number) {
    this.pagination.currentPage = page;
    this.syncRecordList();
  }
  // 页面数据大小切换
  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.syncRecordList();
  }
}
